import { useLocale } from '../i18n/LocaleProvider'
import { usePageTitle } from '../hooks/usePageTitle'
import CorporatePageLayout from '../components/CorporatePageLayout'
import './CompanyPage.css'

const INFO_ROWS_JA = [
  { label: '会社名', value: 'バイバイト株式会社' },
  { label: '設立年月日', value: '2026年2月13日' },
  { label: '代表者名', value: '代表取締役CEO 山﨑日向' },
  { label: '本社所在地', value: '東京都江東区大島8-12-25' },
  { label: '資本金', value: '2万円' },
  {
    label: '役員構成',
    value: (
      <>
        代表取締役CEO 山﨑日向<br />
        取締役CTO兼CPO 松本知大
      </>
    ),
  },
  { label: '従業員数', value: '2名' },
]

const INFO_ROWS_EN = [
  { label: 'Company Name', value: 'Bybeit, Inc.' },
  { label: 'Founded', value: 'February 13, 2026' },
  { label: 'Representative', value: 'Hinata Yamazaki, Representative Director & CEO' },
  { label: 'Head Office', value: '8-12-25 Ojima, Koto-ku, Tokyo, Japan' },
  { label: 'Capital', value: 'JPY 20,000' },
  {
    label: 'Directors',
    value: (
      <>
        Hinata Yamazaki, Representative Director & CEO<br />
        Haruhiro Matsumoto, Director, CTO & CPO
      </>
    ),
  },
  { label: 'Employees', value: '2' },
]

const BUSINESS_ITEMS_JA = [
  '有料職業紹介事業',
  '求人、求職情報提供サービスの企画、運営及び管理業務',
  '人材の育成、職業適性、能力開発のための教育及びカウンセリング業務',
  '研修、セミナー、講演会、講習会等の各種催事の企画、立案、実施、運営及びそれらに関するコンサルティング業務',
  'コンピュータのソフトウェア及びハードウェアの企画、研究、開発、設計、製造、販売、保守、リース、賃貸及び輸出入並びにそれらに関するコンサルティング業務',
  'インターネット等の通信ネットワーク及び電子技術を利用した各種情報提供サービス及び情報収集サービス',
  'コンピュータシステムによるデータ入力及びそれに伴う事務処理の受託',
  '情報の収集、分析、管理及び処理サービス業、情報提供サービス業並びに情報処理に関する研究開発',
  '通信システムによる情報、画像、楽曲の収集、配信、処理、販売並びにそれらに係る機器及び装置類の販売',
  'EC（電子商取引）サイト、その他各種ウェブサイトの企画、制作、販売、配信、運営及び管理',
  '前各号に附帯関連する一切の事業',
]

const BUSINESS_ITEMS_EN = [
  'Fee-charging employment placement services',
  'Planning, operation, and management of job and job-seeker information services',
  'Education and counseling services for human resource development, vocational aptitude, and skills development',
  'Planning, organization, implementation, and operation of training programs, seminars, lectures, workshops, and other events, and consulting services related thereto',
  'Planning, research, development, design, manufacture, sale, maintenance, lease, rental, import, and export of computer software and hardware, and consulting services related thereto',
  'Provision and collection of information using the Internet, other communications networks, and electronic technologies',
  'Outsourced data entry and related administrative processing using computer systems',
  'Collection, analysis, management, and processing of information; information provision services; and research and development relating to information processing',
  'Collection, distribution, processing, and sale of information, images, and music through communications systems, and sale of related equipment and devices',
  'Planning, production, sale, distribution, operation, and management of e-commerce websites and other websites',
  'Any and all businesses incidental or related to the foregoing',
]

const COMPANY_COLUMNS = [
  {
    language: 'ja',
    overviewTitle: '会社概要',
    businessTitle: '事業内容',
    infoRows: INFO_ROWS_JA,
    businessItems: BUSINESS_ITEMS_JA,
  },
  {
    language: 'en',
    overviewTitle: 'Company Overview',
    businessTitle: 'Business Activities',
    infoRows: INFO_ROWS_EN,
    businessItems: BUSINESS_ITEMS_EN,
  },
] as const

export default function CompanyPage() {
  const { locale } = useLocale()
  usePageTitle('Company')
  return (
    <CorporatePageLayout
      title="Company"
      titleLang="en"
      japaneseSubtitle={(
        <>
          バイバイト株式会社の会社概要・法人情報を<br />
          こちらからご確認いただけます。
        </>
      )}
      englishSubtitle={(
        <>
          View Bybeit, Inc.&apos;s company profile and<br />
          corporate information here.
        </>
      )}
    >
      <main className="cp-main container">
        <div className="cp-language-grid">
          {COMPANY_COLUMNS.filter(column => column.language === locale).map((column) => (
            <div
              className={`cp-language-column cp-language-column--${column.language}`}
              key={column.language}
              lang={column.language}
            >
              <section className="cp-section">
                <h2 className="cp-section-label">{column.overviewTitle}</h2>
                <dl className="cp-table">
                  {column.infoRows.map(({ label, value }) => (
                    <div className="cp-row" key={label}>
                      <dt className="cp-row-label">{label}</dt>
                      <dd className="cp-row-value">{value}</dd>
                    </div>
                  ))}
                </dl>
              </section>

              <section className="cp-section cp-section--business">
                <h2 className="cp-section-label">{column.businessTitle}</h2>
                <ol className="cp-business-list">
                  {column.businessItems.map((item, i) => (
                    <li key={item} className="cp-business-item">
                      <span className="cp-business-num">({i + 1})</span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ol>
              </section>
            </div>
          ))}
        </div>
      </main>
    </CorporatePageLayout>
  )
}
